import { motion } from "framer-motion";
import { Check } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export default function About({ about }) {
  return (
    <section id="about" className="relative bg-white py-16 md:py-24 lg:py-28" data-testid="about">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 1, ease: EASE }} className="relative">
            <div className="relative overflow-hidden rounded-lg aspect-[4/3] shadow-[0_25px_50px_-25px_rgba(20,39,58,0.35)]">
              <img src={about?.image} alt="Aerospace manufacturing expertise" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-5 -left-4 sm:-left-5 bg-barn text-white px-6 py-4 rounded-md shadow-lg">
              <div className="font-display font-extrabold text-2xl leading-none">Fort Worth</div>
              <div className="font-body text-[11px] text-white/80 tracking-widest uppercase mt-1">Texas · DFW Metroplex</div>
            </div>
          </motion.div>
        </div>

        <div>
          <motion.span initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="overline text-barn">
            {about?.overline}
          </motion.span>
          <motion.h2 initial={{ opacity: 0, y: 22 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
            className="mt-4 font-display font-extrabold text-3xl md:text-4xl lg:text-[2.7rem] text-navy tracking-tight leading-[1.1]">
            {about?.heading}
          </motion.h2>

          <div className="mt-6 space-y-5 max-w-xl">
            {about?.paragraphs?.map((p, i) => (
              <motion.p key={i} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }} transition={{ duration: 0.7, delay: 0.1 + i * 0.1 }}
                className={i === 2 ? "font-body text-base md:text-lg text-navy font-medium leading-relaxed border-l-[3px] border-barn pl-5" : "font-body text-base md:text-lg text-ink leading-relaxed"}>
                {p}
              </motion.p>
            ))}
          </div>

          <div className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3">
            {about?.credentials?.map((c, i) => (
              <motion.div key={i} initial={{ opacity: 0, x: -10 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.05 }} className="flex items-center gap-2.5">
                <span className="w-5 h-5 rounded-full bg-navy-soft/12 flex items-center justify-center shrink-0"><Check size={12} className="text-navy-soft" /></span>
                <span className="font-body text-sm md:text-[15px] text-navy font-medium">{c}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
